<template>
    <div>
        <h1>Sales Return, Deductions and Charges</h1>
    </div>
</template>
    
<script setup>

</script>